import React from 'react'

import InputAdornment from '@material-ui/core/InputAdornment'
import SearchIcon from '@material-ui/icons/Search'

import colors from '@galo-monitor/styles/colors'
import InputSelect from '@galo-monitor/web-components/InputSelect'

const CustomInputSearch = props => (
  <InputSelect
    InputProps={ {
      endAdornment: (
        <InputAdornment position="end" style={ { marginRight: -25 } }>
          <SearchIcon style={ { color: colors.lightGrey4 } } />
        </InputAdornment>
      )
    } }
    disableClearable
    { ...props }
  />
)

export default CustomInputSearch
